export const WAITLIST_URL = 'https://www.mora-marketer.com';

export const SIGNUP_REFUSED_MESSAGE =
  "Mora is opening in small groups. This email isn't on the access list yet. Join the waitlist and we'll email you when your access is ready.";

export const SIGNUP_REFUSED_TITLE = 'Join the waitlist';

const REFUSAL_PATTERN = /database error saving new user|signup_not_on_allowlist/i;

/**
 * GoTrue reports a refused signup (the auth.users allow-list trigger) as a 500:
 * "Database error saving new user", code `unexpected_failure`. The same shape
 * arrives for an email sign-up (an AuthApiError) and for a Google return (the
 * `error_description` / `error_code` URL parameters). One answer for all of them,
 * and none that says whether a particular address is listed.
 */
export function isSignupRefusal(source: unknown): boolean {
  if (typeof source === 'string') return REFUSAL_PATTERN.test(source);
  if (!source || typeof source !== 'object') return false;
  const { message, code, status } = source as {
    message?: unknown;
    code?: unknown;
    status?: unknown;
  };
  if (typeof message === 'string' && REFUSAL_PATTERN.test(message)) return true;
  return code === 'unexpected_failure' && (status === undefined || status === 500);
}

export function isSignupRefusalDescription(description: string | null | undefined): boolean {
  return REFUSAL_PATTERN.test(description ?? '');
}
